export default __webpack_public_path__ + "static/media/icon-x.5cc943d2.png";